
// Import GSAP core and the ScrollTrigger plugin
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
    // Crossfade images on hover based on data-image attribute
    $('.js-featured-crossfade li a,.js-featured-crossfade li span').on('mouseenter', function () {
        var newImageSrc = $(this).data('image');

        // Get the figure associated with the current .js-featured-crossfade block
        var $blockImageContainer = $(this).closest('.js-featured-crossfade').find('figure');
        var $currentImage = $blockImageContainer.find('img');

        if (newImageSrc && !$blockImageContainer.hasClass('transitioning')) {
            $blockImageContainer.addClass('transitioning');

            var $newImage = $('<img>', {
                src: newImageSrc,
                class: 'img-cover',
                css: { opacity: 0 }
            });

            $newImage.on('load', function() {
                gsap.to($currentImage, {
                    opacity: 0,
                    duration: 0.2,
                    ease: 'power1.inOut',
                    onComplete: function () {
                        $currentImage.remove();
                        $newImage.css('opacity', 0).appendTo($blockImageContainer);
                        gsap.to($newImage, {
                            opacity: 1,
                            duration: 0.2,
                            ease: 'power1.inOut',
                            onComplete: function() {
                                $blockImageContainer.removeClass('transitioning');
                            }
                        });
                    }
                });
            });
        }
    });
});